import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { minorConsentParagraphs, minorConsentPdfUrl } from "@/mocks/legalPages";

/**
 * 親権者同意書について。
 * 本文に続けて、PDFダウンロードボタンを設置する。
 * PDF本体が未アップロード（URLが空）の間は、架空のリンクを作らずボタンを無効表示にする。
 */
export default function ConsentDocument() {
  return (
    <section id="minor-consent-doc" data-anchor className="bg-background-100 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <SectionHeading en="CONSENT FORM" jp="親権者同意書について" />
          </Reveal>

          <Reveal delay={100}>
            <div className="mt-8 space-y-5">
              {minorConsentParagraphs.map((paragraph, index) => (
                <p
                  key={index}
                  className="text-[13px] leading-[2.2] text-foreground-700 md:text-sm"
                >
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-10 md:mt-12">
              {minorConsentPdfUrl ? (
                <a
                  href={minorConsentPdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-md bg-primary-600 px-8 py-4 text-[13.5px] font-medium text-background-50 transition-colors hover:bg-primary-700"
                >
                  <i className="ri-file-download-line text-base" aria-hidden />
                  親権者同意書をダウンロード（PDF）
                </a>
              ) : (
                <span
                  aria-disabled="true"
                  className="inline-flex cursor-not-allowed items-center justify-center gap-2.5 whitespace-nowrap rounded-md border border-foreground-950/15 bg-background-200/60 px-8 py-4 text-[13.5px] text-foreground-500"
                >
                  <i className="ri-file-download-line text-base" aria-hidden />
                  親権者同意書をダウンロード（PDF）
                </span>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}